/**
 * @generated SignedSource<<ab874d3a153c9c5244185b27ff19fd66>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VotableOrder = "HOT" | "NEWEST" | "OLDEST";
export type CommentCommentsFragmentPaginationQuery$variables = {
  bottomLevel?: boolean | null | undefined;
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  id: string;
  level1?: boolean | null | undefined;
  level2?: boolean | null | undefined;
  level3?: boolean | null | undefined;
  order?: VotableOrder | null | undefined;
  topLevel?: boolean | null | undefined;
};
export type CommentCommentsFragmentPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"CommentCommentsFragment">;
  };
};
export type CommentCommentsFragmentPaginationQuery = {
  response: CommentCommentsFragmentPaginationQuery$data;
  variables: CommentCommentsFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "bottomLevel"
},
v1 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "level1"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "level2"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "level3"
},
v7 = {
  "defaultValue": "HOT",
  "kind": "LocalArgument",
  "name": "order"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "topLevel"
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v10 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v10/*:: as any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hotness",
  "storageKey": null
},
v16 = {
  "alias": "viewerCanDelete",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "DELETE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"DELETE_COMMENT\")"
},
v17 = {
  "alias": "viewerCanUpdate",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_COMMENT\")"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edited",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "forum",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v11/*:: as any*/),
            (v12/*:: as any*/)
          ],
          "storageKey": null
        },
        (v12/*:: as any*/)
      ],
      "storageKey": null
    },
    (v12/*:: as any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v12/*:: as any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v12/*:: as any*/),
    (v23/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v24/*:: as any*/),
        (v25/*:: as any*/)
      ],
      "type": "Entity",
      "abstractKey": "__isEntity"
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": "viewerCanReply",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_COMMENT\")"
},
v28 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v29 = [
  (v28/*:: as any*/),
  (v10/*:: as any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numChildren",
  "storageKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voterCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v28/*:: as any*/)
      ],
      "concreteType": "VotersConnection",
      "kind": "LinkedField",
      "name": "voters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EntityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v11/*:: as any*/),
                (v23/*:: as any*/),
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isEntity"
                },
                (v24/*:: as any*/),
                (v25/*:: as any*/),
                (v12/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "voters(first:10)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityVote",
      "kind": "LinkedField",
      "name": "voted",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanVote",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "PUBLISH_VOTE"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"PUBLISH_VOTE\")"
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v34 = {
  "alias": null,
  "args": (v29/*:: as any*/),
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v14/*:: as any*/),
        (v15/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v12/*:: as any*/),
            (v16/*:: as any*/),
            (v17/*:: as any*/),
            (v18/*:: as any*/),
            (v19/*:: as any*/),
            (v20/*:: as any*/),
            (v21/*:: as any*/),
            (v22/*:: as any*/),
            (v26/*:: as any*/),
            (v27/*:: as any*/),
            (v30/*:: as any*/),
            (v11/*:: as any*/),
            (v31/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v32/*:: as any*/),
    (v33/*:: as any*/)
  ],
  "storageKey": null
},
v35 = [
  "order"
],
v36 = {
  "alias": null,
  "args": (v29/*:: as any*/),
  "filters": (v35/*:: as any*/),
  "handle": "connection",
  "key": "CommentCommentsFragment_children",
  "kind": "LinkedHandle",
  "name": "children"
},
v37 = {
  "alias": null,
  "args": (v29/*:: as any*/),
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v14/*:: as any*/),
        (v15/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v12/*:: as any*/),
            (v16/*:: as any*/),
            (v17/*:: as any*/),
            (v18/*:: as any*/),
            (v19/*:: as any*/),
            (v20/*:: as any*/),
            (v21/*:: as any*/),
            (v22/*:: as any*/),
            (v26/*:: as any*/),
            (v27/*:: as any*/),
            (v34/*:: as any*/),
            (v36/*:: as any*/),
            (v11/*:: as any*/),
            (v31/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v32/*:: as any*/),
    (v33/*:: as any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": (v29/*:: as any*/),
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v14/*:: as any*/),
        (v15/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v12/*:: as any*/),
            (v16/*:: as any*/),
            (v17/*:: as any*/),
            (v18/*:: as any*/),
            (v19/*:: as any*/),
            (v20/*:: as any*/),
            (v21/*:: as any*/),
            (v22/*:: as any*/),
            (v26/*:: as any*/),
            (v27/*:: as any*/),
            (v37/*:: as any*/),
            (v36/*:: as any*/),
            (v11/*:: as any*/),
            (v31/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v32/*:: as any*/),
    (v33/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentCommentsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "bottomLevel",
                "variableName": "bottomLevel"
              },
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              {
                "kind": "Variable",
                "name": "level1",
                "variableName": "level1"
              },
              {
                "kind": "Variable",
                "name": "level2",
                "variableName": "level2"
              },
              {
                "kind": "Variable",
                "name": "level3",
                "variableName": "level3"
              },
              (v10/*:: as any*/),
              {
                "kind": "Variable",
                "name": "topLevel",
                "variableName": "topLevel"
              }
            ],
            "kind": "FragmentSpread",
            "name": "CommentCommentsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CommentCommentsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v13/*:: as any*/),
                "concreteType": "CommentConnection",
                "kind": "LinkedField",
                "name": "children",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v14/*:: as any*/),
                      (v15/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/),
                          (v11/*:: as any*/),
                          {
                            "condition": "topLevel",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v16/*:: as any*/),
                              (v17/*:: as any*/),
                              (v18/*:: as any*/),
                              (v19/*:: as any*/),
                              (v20/*:: as any*/),
                              (v21/*:: as any*/),
                              (v22/*:: as any*/),
                              (v26/*:: as any*/),
                              (v27/*:: as any*/),
                              {
                                "alias": null,
                                "args": (v29/*:: as any*/),
                                "concreteType": "CommentConnection",
                                "kind": "LinkedField",
                                "name": "children",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v14/*:: as any*/),
                                      (v15/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v12/*:: as any*/),
                                          (v16/*:: as any*/),
                                          (v17/*:: as any*/),
                                          (v18/*:: as any*/),
                                          (v19/*:: as any*/),
                                          (v20/*:: as any*/),
                                          (v21/*:: as any*/),
                                          (v22/*:: as any*/),
                                          (v26/*:: as any*/),
                                          (v27/*:: as any*/),
                                          (v38/*:: as any*/),
                                          (v36/*:: as any*/),
                                          (v11/*:: as any*/),
                                          (v31/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v32/*:: as any*/),
                                  (v33/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v36/*:: as any*/),
                              (v31/*:: as any*/)
                            ]
                          },
                          {
                            "condition": "level1",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v16/*:: as any*/),
                              (v17/*:: as any*/),
                              (v18/*:: as any*/),
                              (v19/*:: as any*/),
                              (v20/*:: as any*/),
                              (v21/*:: as any*/),
                              (v22/*:: as any*/),
                              (v26/*:: as any*/),
                              (v27/*:: as any*/),
                              (v38/*:: as any*/),
                              (v36/*:: as any*/),
                              (v31/*:: as any*/)
                            ]
                          },
                          {
                            "condition": "level2",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v16/*:: as any*/),
                              (v17/*:: as any*/),
                              (v18/*:: as any*/),
                              (v19/*:: as any*/),
                              (v20/*:: as any*/),
                              (v21/*:: as any*/),
                              (v22/*:: as any*/),
                              (v26/*:: as any*/),
                              (v27/*:: as any*/),
                              (v37/*:: as any*/),
                              (v36/*:: as any*/),
                              (v31/*:: as any*/)
                            ]
                          },
                          {
                            "condition": "level3",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v16/*:: as any*/),
                              (v17/*:: as any*/),
                              (v18/*:: as any*/),
                              (v19/*:: as any*/),
                              (v20/*:: as any*/),
                              (v21/*:: as any*/),
                              (v22/*:: as any*/),
                              (v26/*:: as any*/),
                              (v27/*:: as any*/),
                              (v34/*:: as any*/),
                              (v36/*:: as any*/),
                              (v31/*:: as any*/)
                            ]
                          },
                          {
                            "condition": "bottomLevel",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v16/*:: as any*/),
                              (v17/*:: as any*/),
                              (v18/*:: as any*/),
                              (v19/*:: as any*/),
                              (v20/*:: as any*/),
                              (v21/*:: as any*/),
                              (v22/*:: as any*/),
                              (v26/*:: as any*/),
                              (v27/*:: as any*/),
                              (v30/*:: as any*/),
                              (v31/*:: as any*/)
                            ]
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v32/*:: as any*/),
                  (v33/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v13/*:: as any*/),
                "filters": (v35/*:: as any*/),
                "handle": "connection",
                "key": "CommentCommentsFragment_children",
                "kind": "LinkedHandle",
                "name": "children"
              }
            ],
            "type": "Comment",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3f28737d6676e50f1063cd57a2f9c3b",
    "id": null,
    "metadata": {},
    "name": "CommentCommentsFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query CommentCommentsFragmentPaginationQuery(\n  $bottomLevel: Boolean = false\n  $count: Int = 10\n  $cursor: String\n  $level1: Boolean = false\n  $level2: Boolean = false\n  $level3: Boolean = false\n  $order: VotableOrder = HOT\n  $topLevel: Boolean = false\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...CommentCommentsFragment_Ir66K\n    id\n  }\n}\n\nfragment CommentCommentsFragment_1CbDfQ on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_3zZj4p\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_3zZj4p on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_4hzBTb\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_4hzBTb on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_2rOHm3\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_4kTGy2 on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_1CbDfQ\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_Ir66K on Comment {\n  children(first: $count, after: $cursor, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_4kTGy2 @include(if: $topLevel)\n        ...CommentFragment_1CbDfQ @include(if: $level1)\n        ...CommentFragment_3zZj4p @include(if: $level2)\n        ...CommentFragment_4hzBTb @include(if: $level3)\n        ...CommentFragment_2rOHm3 @include(if: $bottomLevel)\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentDeleteFragment on Comment {\n  id\n  author {\n    id\n  }\n  topic {\n    id\n  }\n  parent {\n    id\n  }\n}\n\nfragment CommentDisplayFragment on Comment {\n  viewerCanDelete: viewerCan(action: DELETE_COMMENT)\n  viewerCanUpdate: viewerCan(action: UPDATE_COMMENT)\n  id\n  content\n  edited\n  createdAt\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n  parent {\n    id\n  }\n  ...CommentDeleteFragment\n  author {\n    id\n    username\n    ...EntityProfilePicFragment_49kWkb\n  }\n  ...VoteDisplayFragment\n}\n\nfragment CommentFragment_1CbDfQ on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_1CbDfQ\n}\n\nfragment CommentFragment_2rOHm3 on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  numChildren\n}\n\nfragment CommentFragment_3zZj4p on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_3zZj4p\n}\n\nfragment CommentFragment_4hzBTb on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_4hzBTb\n}\n\nfragment CommentFragment_4kTGy2 on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_4kTGy2\n}\n\nfragment CommentReplyFragment on Comment {\n  id\n  viewerCanReply: viewerCan(action: CREATE_COMMENT)\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EntitiesAvatarFragment on VotersConnection {\n  edges {\n    node {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment VoteDisplayFragment on Votable {\n  __isVotable: __typename\n  id\n  votes\n  voterCount\n  voters(first: 10) {\n    ...EntitiesAvatarFragment\n  }\n  voted @ifAllowed {\n    score\n  }\n  viewerCanVote: viewerCan(action: PUBLISH_VOTE)\n}\n"
  }
};
})();

(node as any).hash = "68425cd2164ca24e691ae35f11d800b3";

export default node;
